export default {
    notification: state => {
        return state.notification;
    },
}
